import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import RangeByRegionByFacilityTypeStep from "../../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
interface ISelectionByOwnSwapStep_6 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const SelectionByOwnSwapStep_6 = ({
  typeIds,
  selectedPolygonIds,
}: ISelectionByOwnSwapStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_5);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_9);
  };

  const handleRepeatStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_7);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        selectedPolygonIds={selectedPolygonIds ?? []}
        typeIds={typeIds ?? []}
        onNextStep={handleNextStep}
        onRepeatStep={typeIds?.length === 1 ? handleRepeatStep : undefined}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default SelectionByOwnSwapStep_6;
